import { findGetters } from "@dcc/store/getters";
import { SetupContext } from "@vue/composition-api";
import { RouteNames } from "@dcc/router/definitions";

export const useRouting = (context: SetupContext) => {
  const { getNextRoute } = findGetters(context.root.$store);

  const nextRoute = getNextRoute();

  const handleNext = () => {
    context.root.$router.push({ name: nextRoute.value });
    window.scrollTo(0, 0);
  };

  const handlePrev = () => {
    if (context.root.$router.currentRoute.name === RouteNames.profile) {
      context.root.$router.push({ name: RouteNames.welcome });
    } else {
      context.root.$router.go(-1);
    }
  };

  return {
    nextRoute,
    handleNext,
    handlePrev
  };
};
